/* eslint-disable no-undef */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Sound from 'react-sound';


const soundUrl = (soundName) => {
  return `${process.env.PUBLIC_URL}/${soundName || 'alert.mp3'}`;
}
class SoundAlert extends PureComponent {
  render() {
    if (!this.props.shouldPlaySound) {
      return null;
    }

    if (this.props.soundName === 'none') {
      return null;
    }

    return (
      <Sound
        url={soundUrl(this.props.soundName)}
        loop={this.props.loop}
        playStatus={Sound.status.PLAYING}
        onFinishedPlaying={this.props.stopPlaying}
      />
    );
  }
}

SoundAlert.propTypes = {
  shouldPlaySound: PropTypes.bool.isRequired,
  stopPlaying: PropTypes.func.isRequired,
};

export default SoundAlert;
